<template>
    <div class="j-user-ctrl-wrap">
        <el-dropdown v-if="isLogin" size="small">
            <div class="j-user-ctrl-box">
                <el-avatar :title="name" size="medium" :src="getUrlByPath(avatar)" @error="errorHandler">{{name}}</el-avatar>
                <span class="j-user-ctrl-box_name" :title="name">{{name}}</span>
                <i class="el-icon-arrow-down" />
            </div>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="reset" >重置密码</el-dropdown-item>
                <template v-if="theme">
                    <el-dropdown-item v-if="theme === 'light'" @click.native="themeStyle('dark')" >暗色主题</el-dropdown-item>
                    <el-dropdown-item v-else @click.native="themeStyle('light')" >亮色主题</el-dropdown-item>
                </template>
                <el-dropdown-item @click.native="logout" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <div v-else class="j-user-ctrl-box">
            <span class="j-user-ctrl-box_name" @click="$router.push('/login')">登录</span>
        </div>
        <j-reset-pwd :close.sync="showPwd" />
    </div>
</template>

<script>
    import JResetPwd from "./components/JResetPwd";
    import oss from "../JTool/oss/oss";
    import {web} from "@/config";
    export default {
        name: "JAvatar",
        components: {
            JResetPwd
        },
        computed: {
            isLogin () {
                return !!this.$store.state.user.adminId
            },
            name () {
                return this.$store.state.user.name
            },
            avatar () {
                return this.$store.state.user.avataUrl
            },
            theme () {
                return this.$store.state.theme
            }
        },
        data () {
            return {
                showPwd: false
            }
        },
        mounted () {
            this.changeTheme(this.theme)
        },
        methods: {
            changeTheme (theme) {
                document.body.className = theme
            },
            getUrlByPath: oss.getUrlByGenerateName,
            errorHandler() {
                return true
            },
            themeStyle (theme) {
              this.changeTheme(theme)
              this.setThemeStyle(theme)
              this.$store.commit('theme', theme)
            },
            async setThemeStyle (theme) {
                const { data } = await this.$http.put(`/api/admins/updateTheme`, { adminId: this.$store.state.user.adminId, theme })
                if (data.status !== 'yes') return console.error(data.msg || data.message || '主题保存失败')
            },
            reset () {
                this.showPwd = true
            },
            async logout () {
                const { data } = await this.$http.post(`/api/admins/logout`);
                if (data.status !== 'yes') return this.$message.error(data.msg);
                window.sessionStorage.clear();
                location.href = web
            }
        }
    }
</script>

<style scoped lang="scss">
    .j-user-ctrl-wrap {
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        .j-user-ctrl-box {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            /*color: #fff;*/
            .j-user-ctrl-box_name {
                font-size: 14px;
                font-weight: bold;
                max-width: 70px;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break: keep-all;
                margin: 0 2px 0 6px;
                &:hover {
                    text-decoration: underline;
                    cursor: pointer;
                }
            }
            >i {
                display: inline-block;
                height: 20px;
                line-height: 22px;
            }
        }
        .el-dropdown {
            height: 100%;
            width: 100%;
            display: block;
        }
    }
</style>
